import React, { useState, useEffect } from "react";
import MaxDetailModal from "../components/MaxDetailModal";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { NumericFormat } from "react-number-format";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Vendors() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [VendorList, setVendorList] = useState([]);
  const [MyVendorList, setMyVendorList] = useState([]);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { setIsLoggedIn } = useOutletContext();
  const [vendorStates, setVendorStates] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState(new Set());
  const [selectedCategory, setSelectedCategory] = useState("default_option");

  const [showMaxModal, setShowMaxModal] = useState(false);
  const [selectedVendorGames, setSelectedVendorGames] = useState([]);
  const [selectedModalVendor, setSelectedModalVendor] = useState(null);
  const [limitList, setLimitList] = useState([]);
  const [skinBatchLevels, setSkinBatchLevels] = useState({
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
  });
  const [skinBatchLoading, setSkinBatchLoading] = useState(false);
  const [skinBatchCats, setSkinBatchCats] = useState({
    all: true,
    casino: false,
    slot: false,
  });

  const toggleSkinBatchCat = (key) => {
    if (key === "all") {
      setSkinBatchCats({ all: true, casino: false, slot: false });
      return;
    }
    setSkinBatchCats((prev) => {
      const next = { ...prev, all: false, [key]: !prev[key] };
      if (!next.casino && !next.slot) {
        return { all: true, casino: false, slot: false };
      }
      return next;
    });
  };

const fetchVendorList = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(`${API_BASE}/api/MyVendorList`, {
      params: {
        userId: user.user_id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setVendorList(res.data.List);
    setMyVendorList(res.data.myList);
  } catch (err) {
    if (axios.isAxiosError(err) && err.response) {
      if (
        err.response.status === 401 ||
        err.response.status === 403 ||
        err.response.status === 500
      ) {
        localStorage.removeItem("token");
        setIsLoggedIn(false);
        navigate("/login");
        return;
      }
    }
    console.error("유저 정보 불러오기 실패:", err);
  }
};

const toggleVendorStatus = async (vendor) => {
  const isCurrentlyNormal = vendor.V_use === 1;
  const nextStatus = isCurrentlyNormal ? 0 : 1;

  const confirmMsg = isCurrentlyNormal
    ? "해당 벤더를 점검 상태로 전환하시겠습니까?"
    : "해당 벤더를 정상 상태로 전환하시겠습니까?";

  if (!window.confirm(confirmMsg)) return;

  try {
    const token = localStorage.getItem("token");

    await axios.post(
      `${API_BASE}/api/vendor/updateStatus`,
      {
        v_code: vendor.v_code,
        V_use: nextStatus,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    alert("상태가 변경되었습니다.");

    // ✅ 방법 1: 목록 다시 불러오기 (가장 안전)
    fetchVendorList();

    // ✅ 방법 2: 즉시 UI 반영 (optimistic update)
    /*
    setVendorList((prev) =>
      prev.map((v) =>
        v.v_code === vendor.v_code
          ? { ...v, V_use: nextStatus }
          : v
      )
    );
    */
  } catch (err) {
    console.error(err);
    alert("상태 변경 중 오류가 발생했습니다.");
  }
};


  const isVendorGameReady = (vendorCode) => {
    return (
      Array.isArray(limitList) &&
      limitList.some((item) => item.vendor === vendorCode)
    );
  };

  const filteredVendors = (Array.isArray(VendorList) ? VendorList : []).filter(
    (vendor) => {
      if (selectedCategory === "default_option") return true;
      return vendor.v_type === selectedCategory;
    },
  );

  useEffect(() => {
    if (!user || !user.user_id) return;

    const fetchLimitData = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(`${API_BASE}/api/UserGameLimit`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setLimitList(res.data.list); // ⭐ 핵심 부분
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false);
            navigate("/login");
            return;
          }
        }
        console.error("유저 게임 제한정보 불러오기 실패:", err);
      }
    };

    fetchLimitData();
  }, [user]);

  const openDetailModal = (vendor) => {
    // 1️⃣ 해당 벤더의 게임들만 필터링
    const vendorGames = limitList.filter(
      (item) => item.vendor === vendor.v_code,
    );

    // 2️⃣ 모달에 넘길 데이터 가공
    const gameItems = vendorGames.map((g) => ({
      gameId: g.gameId,
      nameKR: g.game_name_kor ?? g.game_name, // KR/EN 분리 안 돼 있으면 동일 사용
      nameEN: g.game_name,
      maxi: g.maxi,
      bet_maxi: g.bet_maxi ?? 0,

      // 값 변경
      onChange: (val) => {
        const num = Number(val.replace(/\D/g, ""));
        setLimitList((prev) =>
          prev.map((x) =>
            x.gameId === g.gameId && x.vendor === vendor.v_code
              ? { ...x, bet_maxi: num }
              : x,
          ),
        );
      },

      // 업데이트
      onUpdate: async (newMaxi) => {
        const token = localStorage.getItem("token");

        await axios.post(
          `${API_BASE}/api/updateGameLimit`,
          {
            userId: user.user_id,
            vendor: vendor.v_code,
            gameId: g.gameId,
            maxi: newMaxi,
            bet: 1,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        // ---------------------------
        // ⭐ React 상태 즉시 업데이트
        // ---------------------------
        setLimitList((prev) =>
          prev.map((item) =>
            item.gameId === g.gameId && item.vendor === vendor.v_code
              ? { ...item, bet_maxi: Number(newMaxi) }
              : item,
          ),
        );

        alert("게임 한도 수정 완료");
      },

      // 초기화
      onReset: async () => {
        const token = localStorage.getItem("token");

        await axios.post(
          `${API_BASE}/api/updateGameLimit`,
          {
            userId: user.user_id,
            vendor: vendor.v_code,
            gameId: g.gameId,
            maxi: 5000000,
            bet: 1,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        // ⭐ 부모 state 갱신
        setLimitList((prev) =>
          prev.map((item) =>
            item.gameId === g.gameId && item.vendor === vendor.v_code
              ? { ...item, bet_maxi: 5000000 }
              : item,
          ),
        );

        // ⭐ 모달용 상태도 즉시 업데이트 (중요)
        setSelectedVendorGames((prev) =>
          prev.map((item) =>
            item.gameId === g.gameId ? { ...item, bet_maxi: 5000000 } : item,
          ),
        );

        alert("초기화 완료");
      },
    }));

    // 3️⃣ 모달에 전달
    setSelectedModalVendor(vendor);
    setSelectedVendorGames(gameItems);

    // 4️⃣ 모달 열기
    setShowMaxModal(true);
  };

  const handleModalBatchBetLimit = async (amount, gameIds) => {
    if (!selectedModalVendor) return;
    const token = localStorage.getItem("token");
    const vendorCode = selectedModalVendor.v_code;

    await Promise.all(
      gameIds.map((gameId) =>
        axios.post(
          `${API_BASE}/api/updateGameLimit`,
          {
            vendor: vendorCode,
            gameId,
            maxi: amount,
            bet: 1,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        ),
      ),
    );

    setLimitList((prev) =>
      prev.map((item) =>
        item.vendor === vendorCode && gameIds.includes(item.gameId)
          ? { ...item, bet_maxi: Number(amount) }
          : item,
      ),
    );
    setSelectedVendorGames((prev) =>
      prev.map((item) =>
        gameIds.includes(item.gameId)
          ? { ...item, bet_maxi: Number(amount) }
          : item,
      ),
    );
  };

  const handleSkinBatchApply = async () => {
    const levelsToApply = [1, 2, 3, 4, 5]
      .map((level) => ({
        level,
        maxi: String(skinBatchLevels[level] || "").replace(/[^0-9]/g, ""),
      }))
      .filter((x) => x.maxi !== "");

    if (levelsToApply.length === 0) {
      alert("변경할 레벨 금액을 입력해주세요");
      return;
    }

    const targetVendors = (Array.isArray(VendorList) ? VendorList : []).filter(
      (v) => {
        if (skinBatchCats.all) return true;
        if (skinBatchCats.casino && v.v_type === "casino") return true;
        if (skinBatchCats.slot && v.v_type === "slot") return true;
        return false;
      },
    );
    const targetCodes = targetVendors.map((v) => v.v_code);

    if (targetCodes.length === 0) {
      alert("적용할 벤더가 없습니다. 카테고리를 선택해주세요");
      return;
    }

    const catLabel = skinBatchCats.all
      ? "전체"
      : [
          skinBatchCats.casino ? "카지노" : null,
          skinBatchCats.slot ? "슬롯" : null,
        ]
          .filter(Boolean)
          .join(", ");

    if (
      !window.confirm(
        `${catLabel} 벤더 ${targetCodes.length}개에 스킨한도(레벨 ${levelsToApply
          .map((x) => x.level)
          .join(", ")})를 일괄 적용할까요?`,
      )
    ) {
      return;
    }

    setSkinBatchLoading(true);
    const token = localStorage.getItem("token");

    try {
      const calls = [];
      for (const vendorCode of targetCodes) {
        for (const { level, maxi } of levelsToApply) {
          calls.push(
            axios.post(
              `${API_BASE}/api/updateVendorMaxi`,
              { vendorCode, level, maxi: Number(maxi) },
              { headers: { Authorization: `Bearer ${token}` } },
            ),
          );
        }
      }
      await Promise.all(calls);

      setMyVendorList((prev) =>
        prev.map((item) => {
          if (!targetCodes.includes(item.a_thirdparty)) return item;
          const found = levelsToApply.find((x) => x.level === item.level);
          return found ? { ...item, maxi: Number(found.maxi) } : item;
        }),
      );

      alert("스킨한도 일괄변경 완료");
    } catch (err) {
      console.error(err);
      alert("스킨한도 일괄변경 중 오류가 발생했습니다");
    } finally {
      setSkinBatchLoading(false);
    }
  };

  useEffect(() => {
    if (!VendorList || !MyVendorList) return;

    const initialStates = VendorList.map((vendor) => {
      const levels = MyVendorList.filter(
        (item) => item.a_thirdparty === vendor.v_code,
      ).sort((a, b) => a.level - b.level);

      return {
        v_code: vendor.v_code,
        isActive: levels.length > 0 && levels[0].game_use === "Y",
      };
    });

    setVendorStates(initialStates);
  }, [VendorList]);

  const getVendorState = (vcode) =>
    vendorStates.find((v) => v.v_code === vcode);

  const toggleVendorState = (vcode) => {
    setVendorStates((prev) =>
      prev.map((v) =>
        v.v_code === vcode ? { ...v, isActive: !v.isActive } : v,
      ),
    );
  };

  const handleMaxiChange = (vendorCode, levelNum, value) => {
    setMyVendorList((prev) =>
      prev.map((item) =>
        item.a_thirdparty === vendorCode && item.level === levelNum
          ? { ...item, maxi: Number(value) }
          : item,
      ),
    );
  };

  const handleResetMaxi = async (vendorCode, levelNum) => {
    try {
      const token = localStorage.getItem("token");

      // 1️⃣ API 호출 (초기화 = 5000000)
      await axios.post(
        `${API_BASE}/api/updateVendorMaxi`,
        {
          userId: user.user_id,
          vendorCode,
          level: levelNum,
          maxi: 5000000,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // 2️⃣ 성공 시 로컬 상태 반영
      setMyVendorList((prev) =>
        prev.map((item) =>
          item.a_thirdparty === vendorCode && item.level === levelNum
            ? { ...item, maxi: 5000000 }
            : item,
        ),
      );

      alert("초기화 완료");
    } catch (err) {
      console.error(err);
      alert("초기화 실패");
    }
  };

  const handleBatchApply = async () => {
    if (selectedVendors.size === 0) {
      alert("먼저 벤더를 선택해주세요");
      return;
    }

    const codes = Array.from(selectedVendors);
    const token = localStorage.getItem("token");

    // 1) 각 벤더별 game_use 상태 계산
    const useUpdates = codes.map((vcode) => {
      const st = getVendorState(vcode);
      return { vendorCode: vcode, game_use: st?.isActive ? "Y" : "N" };
    });

    try {
      // 2) game_use 일괄 API 호출 (각각)
      await Promise.all(
        useUpdates.map(({ vendorCode, game_use }) =>
          axios.post(
            `${API_BASE}/api/updateVendorUse`,
            { vCodes: [vendorCode], game_use },
            { headers: { Authorization: `Bearer ${token}` } },
          ),
        ),
      );

      // 3) 로컬 상태 반영 (game_use)
      setMyVendorList((prev) =>
        prev.map((item) => {
          const u = useUpdates.find((u) => u.vendorCode === item.a_thirdparty);
          return u ? { ...item, game_use: u.game_use } : item;
        }),
      );

      // 4) maxi 일괄 API 호출
      const maxiCalls = MyVendorList.flatMap((item) => {
        if (!selectedVendors.has(item.a_thirdparty)) return [];
        return axios.post(
          `${API_BASE}/api/updateVendorMaxi`,
          {
            vendorCode: item.a_thirdparty,
            level: item.level,
            maxi: item.maxi,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
      });
      await Promise.all(maxiCalls);

      alert("선택된 벤더의 활성화 상태와 한도가 모두 적용되었습니다");
      setSelectedVendors(new Set());
    } catch (err) {
      console.error(err);
      alert("일괄 적용 중 오류가 발생했습니다");
    }
  };
  const handleBatchToggle = async () => {
    if (selectedVendors.size === 0) {
      alert("먼저 벤더를 선택해주세요");
      return;
    }

    const codes = Array.from(selectedVendors);
    const token = localStorage.getItem("token");

    // 첫 번째 선택된 벤더의 현 상태(game_use) 확인
    const firstCode = codes[0];
    const firstLevels = MyVendorList.filter(
      (item) => item.a_thirdparty === firstCode,
    ).sort((a, b) => a.level - b.level);
    if (!firstLevels.length) {
      alert("벤더 데이터가 없습니다");
      return;
    }
    const currentUse = firstLevels[0].game_use; // 'Y' 또는 'N'
    const targetUse = currentUse === "Y" ? "N" : "Y"; // 반대값

    try {
      // API 요청: 선택된 모든 vCodes에 대해 동일한 game_use 적용
      await axios.post(
        `${API_BASE}/api/updateVendorUse`,
        { vCodes: codes, game_use: targetUse },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // 로컬 상태에도 반영
      setMyVendorList((prev) =>
        prev.map((item) =>
          codes.includes(item.a_thirdparty)
            ? { ...item, game_use: targetUse }
            : item,
        ),
      );
      setSelectedVendors(new Set());
      alert(
        `선택된 벤더가 모두 ${
          targetUse === "Y" ? "활성화" : "비활성화"
        }되었습니다`,
      );
    } catch (err) {
      console.error(err);
      alert("일괄 토글 실패");
    }
  };

  const handleEditMaxi = async (vendorCode, level, value) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${API_BASE}/api/updateVendorMaxi`,
        {
          userId: user.user_id,
          vendorCode,
          level,
          maxi: value,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data.success) {
        alert("수정되었습니다");
      }
    } catch (err) {
      alert("업데이트 실패");
    }
  };

useEffect(() => {
  if (!user || !user.user_id) return;
  fetchVendorList();
}, [user]);


  useEffect(() => {
    const storedUser = localStorage.getItem("first");

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (e) {
        console.error("유저 정보 파싱 오류:", e);
      }
    }
  }, []);

  if (!VendorList || !MyVendorList) {
    return <div>로딩 중...</div>;
  }
  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block vVenderLists" id="opt-x">
              <div className="card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3">
                    <div className="nk-block nk-block-lg">
                      <div className="mb-0">
                        <div className="row tbSearch g-2 align-items-center">
                          <div className="col-12 col-md-3">
                            <select
                              className="form-select js-select2"
                              id="selectCategory"
                              value={selectedCategory}
                              onChange={(e) =>
                                setSelectedCategory(e.target.value)
                              }
                            >
                              <option value="default_option">전체</option>
                              <option value="casino">카지노</option>
                              <option value="slot">슬롯</option>
                            </select>
                          </div>
                          <div className="col-12 col-md-9">
                            <div className="btn-group flex-wrap">
                              <button
                                type="button"
                                className="btn btn-outline-info btn-dim"
                                onClick={handleBatchToggle}
                              >
                                <i className="fas fa-check" />
                                <font>선택 활성/비활성</font>
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-dim"
                                onClick={handleBatchApply}
                              >
                                <i className="fas fa-bolt" />
                                <font>선택 수정</font>
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-warning btn-dim"
                                data-bs-target="#collapseExample"
                                data-bs-toggle="collapse"
                              >
                                <i className="fas fa-question" />
                                <font>도움말</font>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="text-danger mt-3 mb-2">
                          <div>
                            * <b>회원 당첨금 처리시 유의사항</b>
                          </div>
                          <div>- 심리스 API</div>
                          <div className="font-lg">
                            에이전트에게 모든 금액이 지급됩니다
                          </div>
                          <div className="mt-2">- 트랜스퍼 API</div>
                          <div className="font-lg">
                            회원 당첨금은 한도 금액까지 지급이 되고 나머지
                            금액은 에이전트에게 지급됩니다
                          </div>
                          <div className="font-lg">
                            API 에서 베팅 로그를 받을시에 유저 당첨금(amount) 과
                            초과 당첨금(totalAmount)이 나뉘어서 로그가
                            발송되오니 참고 바랍니다
                          </div>
                        </div>

                        <div className="card card-bordered mt-2">
                          <div className="card-inner py-3">
                            <div className="fw-bold mb-2">스킨한도 일괄변경</div>
                            <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="skinCatAll"
                                  checked={skinBatchCats.all}
                                  onChange={() => toggleSkinBatchCat("all")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="skinCatAll"
                                >
                                  전체
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="skinCatCasino"
                                  checked={skinBatchCats.casino}
                                  onChange={() => toggleSkinBatchCat("casino")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="skinCatCasino"
                                >
                                  카지노
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="skinCatSlot"
                                  checked={skinBatchCats.slot}
                                  onChange={() => toggleSkinBatchCat("slot")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="skinCatSlot"
                                >
                                  슬롯
                                </label>
                              </div>
                            </div>
                            <div className="row g-2 align-items-center">
                              {[1, 2, 3, 4, 5].map((level) => (
                                <div
                                  key={level}
                                  className="col-6 col-sm-4 col-md-2"
                                >
                                  <div className="input-group input-group-sm">
                                    <span className="input-group-text">
                                      {level}레벨
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      inputMode="numeric"
                                      style={{ textAlign: "right" }}
                                      placeholder="금액"
                                      value={skinBatchLevels[level]}
                                      disabled={skinBatchLoading}
                                      onChange={(e) =>
                                        setSkinBatchLevels((prev) => ({
                                          ...prev,
                                          [level]: e.target.value.replace(
                                            /[^0-9]/g,
                                            "",
                                          ),
                                        }))
                                      }
                                    />
                                  </div>
                                </div>
                              ))}
                              <div className="col-12 col-md-2">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm w-100"
                                  onClick={handleSkinBatchApply}
                                  disabled={skinBatchLoading}
                                >
                                  <i className="fas fa-bolt" />{" "}
                                  {skinBatchLoading
                                    ? "적용 중..."
                                    : "일괄적용"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="collapse" id="collapseExample">
                          <br />
                          <div className="alert alert-secondary">
                            <div className="">
                              {" "}
                              1. 선택 활성/비활성: check를 선택하여
                              활성화/비활성화 변경이 가능합니다.
                            </div>
                            <div className="">
                              {" "}
                              2. 선택 수정: 변경 사항은 파란색으로 표시되며 선택
                              수정을 클릭시 항목이 수정됩니다.
                            </div>
                            <div className="text-danger">
                              3. 베팅한도: 설정한 금액 이상으로 베팅이
                              불가능합니다.
                            </div>
                            <div className="text-danger">
                              {" "}
                              4. (베팅한도 : 오른쪽의 수정/초기화 버튼을
                              사용하여 조정해주시기 바랍니다)
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-inner tableBox p-0">
                    <div
                      className="table-wrapper"
                      style={{
                        borderTop: "1px dotted #BBB",
                        paddingTop: "5px 0",
                      }}
                    >
                      <div
                        className="table-responsive"
                        data-pattern="priority-columns"
                      >
                        <div data-pattern="priority-columns">
                          <table
                            cellSpacing="0"
                            className="table table-small-font table-bordered table-striped vam"
                            id="batlist"
                          >
                            <thead>
                              <tr data-pos-y="0">
                                <th
                                  className="text-center"
                                  data-pos-x="0"
                                  data-priority="1"
                                  id="batlist-col-0"
                                >
                                  check
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="1"
                                  data-priority="1"
                                  id="batlist-col-1"
                                >
                                  활성
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="2"
                                  data-priority="1"
                                  id="batlist-col-2"
                                >
                                  점검여부
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="3"
                                  data-priority="1"
                                  id="batlist-col-3"
                                >
                                  게임 개별 설정
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="4"
                                  data-priority="1"
                                  id="batlist-col-4"
                                >
                                  카테고리
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="5"
                                  data-priority="1"
                                  id="batlist-col-5"
                                >
                                  벤더
                                </th>
                                <th
                                  className="text-center"
                                  data-bs-original-title="베팅한도/ 당첨한도 설정은 하단의 버튼을 사용해주세요"
                                  data-pos-x="7"
                                  data-priority="1"
                                  data-toggle="tooltip"
                                  id="batlist-col-7"
                                >
                                  스킨 한도{" "}
                                  <em className="icon ni ni-info-fill vam" />
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="8"
                                  data-priority="1"
                                  id="batlist-col-8"
                                >
                                  처리시간
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredVendors.map((vendor, index) => {
                                const levels = MyVendorList.filter(
                                  (item) => item.a_thirdparty === vendor.v_code,
                                ).sort((a, b) => a.level - b.level);
                                const state = getVendorState(vendor.v_code);
                                const firstLevel = levels[0] || null;

                                return (
                                  <tr key={vendor.v_code} data-pos-y={index}>
                                    {/* 체크박스 */}
                                    <td className="text-center">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={firstLevel?.idx ?? vendor.v_code}
                                        checked={selectedVendors.has(
                                          vendor.v_code,
                                        )}
                                        onChange={(e) => {
                                          const s = new Set(selectedVendors);
                                          if (e.target.checked)
                                            s.add(vendor.v_code);
                                          else s.delete(vendor.v_code);
                                          setSelectedVendors(s);
                                        }}
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      />
                                    </td>

                                    {/* 점검 여부 */}
                                    <td className="text-center">
                                      <div
                                        className={`custom-control switch-onoff custom-switch ms-2 ${
                                          state?.isActive ? "checked" : ""
                                        }`}
                                      >
                                        <input
                                          className="custom-control-input"
                                          id={`sw-${index}`}
                                          type="checkbox"
                                          checked={state?.isActive}
                                          onChange={() =>
                                            toggleVendorState(vendor.v_code)
                                          }
                                        />
                                        <label
                                          className="custom-control-label text-nowrap"
                                          htmlFor={`sw-${index}`}
                                        >
                                          <strong />
                                        </label>
                                      </div>
                                    </td>

                                    {/* 상태 */}
                                    <td className="text-center">
                                      {/* 현재 상태 표시 */}
                                      <span
                                        className={
                                          vendor.V_use === 1
                                            ? "text-success fw-bold"
                                            : "text-warning fw-bold"
                                        }
                                      >
                                        {vendor.V_use === 1 ? (
                                          <>
                                            <i className="fas fa-check-circle me-1" />{" "}
                                            정상
                                          </>
                                        ) : (
                                          <>
                                            <i className="fas fa-tools me-1" />{" "}
                                            점검
                                          </>
                                        )}
                                      </span>

                                      {/* root 전용 버튼 */}
                                      {user.user_id === "root" && (
                                        <div className="mt-1">
                                          <button
                                            className={`btn btn-sm ${
                                              vendor.V_use === 1
                                                ? "btn-warning"
                                                : "btn-success"
                                            }`}
                                            title={
                                              isVendorGameReady(vendor.v_code)
                                                ? ""
                                                : "게임 데이터를 불러오는 중입니다"
                                            }
                                            onClick={() => toggleVendorStatus(vendor)}
                                          >
                                            {vendor.V_use === 1 ? (
                                              <>
                                                <i className="fas fa-tools me-1" />{" "}
                                                점검으로 전환
                                              </>
                                            ) : (
                                              <>
                                                <i className="fas fa-check-circle me-1" />{" "}
                                                정상으로 전환
                                              </>
                                            )}
                                          </button>
                                        </div>
                                      )}
                                    </td>

                                    {/* 정렬 (고정) */}
                                    <td className="text-center">
                                      <button
                                        className="btn btn-sm btn-primary"
                                        disabled={
                                          !isVendorGameReady(vendor.v_code)
                                        }
                                        onClick={() => openDetailModal(vendor)}
                                        title={
                                          isVendorGameReady(vendor.v_code)
                                            ? ""
                                            : "게임 데이터를 불러오는 중입니다"
                                        }
                                      >
                                        <i className="fas fa-edit" /> 세부
                                        게임별 설정
                                      </button>
                                    </td>

                                    {/* 카테고리 */}
                                    <td className="text-center">
                                      {vendor.v_type === "casino"
                                        ? "카지노"
                                        : "슬롯"}
                                    </td>

                                    {/* 벤더 이름 */}
                                    <td className="text-center">
                                      {vendor.v_name_kor} <br />
                                      <span className="text-info">
                                        {vendor.v_code}
                                      </span>
                                    </td>

                                    {/* 베팅한도 */}
                                    <td className="text-center">
                                      {levels.length > 0 ? (
                                        levels.map((level) => (
                                          <div
                                            className="input-group"
                                            key={level.level}
                                          >
                                            <div className="input-group-prepend">
                                              <span className="input-group-text">
                                                {level.level} 레벨
                                              </span>
                                            </div>
                                            <div className="input-group-prepend">
                                              <span className="input-group-text">
                                                베팅한도
                                              </span>
                                            </div>
                                            <NumericFormat
                                              className="form-control"
                                              placeholder="인게임 한도"
                                              style={{ textAlign: "right" }}
                                              value={level.maxi}
                                              thousandSeparator=","
                                              onValueChange={({ value }) => {
                                                // value: 콤마 없는 숫자 문자열
                                                handleMaxiChange(
                                                  vendor.v_code,
                                                  level.level,
                                                  value,
                                                );
                                              }}
                                            />
                                            <button
                                              className="btn btn-sm btn-primary"
                                              onClick={() =>
                                                handleEditMaxi(
                                                  vendor.v_code,
                                                  level.level,
                                                  level.maxi,
                                                )
                                              }
                                            >
                                              <i className="fas fa-edit" />
                                              <font>수정</font>
                                            </button>
                                            <button
                                              className="btn btn-sm btn-outline-danger"
                                              onClick={() =>
                                                handleResetMaxi(
                                                  vendor.v_code,
                                                  level.level,
                                                )
                                              }
                                            >
                                              <i className="fas fa-redo-alt" />
                                              <font>초기화</font>
                                            </button>
                                          </div>
                                        ))
                                      ) : (
                                        <span>데이터 없음</span>
                                      )}
                                    </td>

                                    {/* 등록일/수정일 */}
                                    <td className="text-center">
                                      {firstLevel ? (
                                        <>
                                          <div className="date-log">
                                            <span className="small badge bg-blue me-2">
                                              등록일
                                            </span>
                                            <div>
                                              <span style={{ fontSize: "95%" }}>
                                                {dayjs(firstLevel.reg_dt)
                                                  .tz("Asia/Seoul")
                                                  .format("YYYY-MM-DD")}
                                                <font className="dateInHour">
                                                  {" "}
                                                  (
                                                  {dayjs(firstLevel.reg_dt)
                                                    .tz("Asia/Seoul")
                                                    .format("HH:mm:ss")}{" "}
                                                  UTC +9)
                                                </font>
                                              </span>
                                            </div>
                                          </div>
                                          <hr className="m-0" />
                                          <div className="date-log">
                                            <span className="small badge bg-info me-2">
                                              수정일
                                            </span>
                                            <div>
                                              <span style={{ fontSize: "95%" }}>
                                                {dayjs(firstLevel.updated_at)
                                                  .tz("Asia/Seoul")
                                                  .format("YYYY-MM-DD")}
                                                <font className="dateInHour">
                                                  {" "}
                                                  (
                                                  {dayjs(firstLevel.updated_at)
                                                    .tz("Asia/Seoul")
                                                    .format("HH:mm:ss")}{" "}
                                                  UTC +9)
                                                </font>
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <span>데이터 없음</span>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MaxDetailModal
        show={showMaxModal}
        onClose={() => {
          setShowMaxModal(false);
          setSelectedModalVendor(null);
        }}
        gameList={selectedVendorGames}
        bet={1}
        onBatchUpdate={handleModalBatchBetLimit}
      />
    </div>
  );
}
